// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import iView from 'iview'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App'
import router from './router'

import instance from './config/request'
import store from './vuex/store'
import API from '@/config/api'
import Commons from '@/config/commons'
import Bus from '@/utils/bus';

import MainMenu from '@/components/Menu'
import HeaderBar from '@/components/Header'
import VueCookie from 'vue-cookie'
import VueResource from 'vue-resource'

import uploader from 'vue-simple-uploader'
import interact from 'interactjs'
import * as svgicon from 'vue-svgicon';

import './axios'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(iView)

Vue.use(VueCookie);
Vue.use(VueResource);
Vue.use(uploader)

Vue.use(svgicon, {
    tagName: 'svgicon'
});

// 公共组件
Vue.component('main-menu', MainMenu);
Vue.component('header-bar', HeaderBar);

import 'iview/dist/styles/iview.css'

// 属性扩充
//Vue.prototype.$http = instance;
Vue.prototype.$API = API;
Vue.prototype.$interact = interact

//Vue.http.options.emulateJSON = true
//Vue.http.options.headers = {
//    'Content-Type': 'application/x-www-form-urlencoded'
//}
//Vue.http.interceptors.push((request, next) => {
//
//})

router.beforeEach((to, from, next) => {
    iView.LoadingBar.start();
    if (to.params.appId) {
        console.log('router app id:', to.params.appId);
        API.APPID = to.params.appId;
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        const domain = {
            domain: Commons.getDomain()
        };
        let username = VueCookie.get('USER_NAME');
        let uname = sessionStorage.getItem('userName');
        if (uname == null || username == null || username == 'admin' || !VueCookie.get('WEBUI_WEBAPI_TOKEN')) {
            sessionStorage.removeItem('localMenu')
            sessionStorage.removeItem('userName')
            sessionStorage.removeItem('userAccount')
            let url = '/passport-webapi/session';
            Vue.http.get(url).then(function (response) {
                let m = response.body;
                if (m.error == 'success' || m.rc == '0') {
                    sessionStorage.setItem('userName', m.name)
                    sessionStorage.setItem('userAccount', m.email)
                    VueCookie.set('USER_NAME', m.name);
                    VueCookie.set('WEBUI_WEBAPI_TOKEN', m.token);
                    Commons.getAppIds(next);
                } else { // not login
                    VueCookie.delete('USER_NAME', domain);
                    VueCookie.delete('WEBUI_WEBAPI_TOKEN', domain);
                    console.log('invalidate: ' + process.env.NODE_ENV);
                    console.log(API.LOGIN_URL);
                    //if (process.env.NODE_ENV != 'development') {
                        iView.LoadingBar.finish();
                        //window.location.href = API.LOGIN_URL;
                        router.replace('/login')
                    //}
                }
            }, function() {
                console.log('invalidate: ' + process.env.NODE_ENV);
                console.log(API.LOGIN_URL);
	            //if (process.env.NODE_ENV != 'development') {
		            iView.LoadingBar.finish();
                    //window.location.href = API.LOGIN_URL;
                    router.replace('/login')
		        //}
            });
        } else {
            Commons.getAppIds(next)
        }
    } else {
        next() // 确保一定要调用 next()
    }

    if (to.matched.some(record => record.meta.mainMenuId)) {
	var menu = to.matched.find(record => record.meta.mainMenuId)
	Bus.mainMenuId = menu.meta.mainMenuId
	Bus.$emit('menu-update', menu.meta.mainMenuId)
    } else {
	next()
    }
});

router.afterEach(to => {
    iView.LoadingBar.finish()
    window.scrollTo(0, 0)
});

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   store: store,
//   template: '<App/>',
//   components: { App }
// })
new Vue({
    router,
    store: store,
    render: (h) => h(App),
  }).$mount("#app");
  



// WEBPACK FOOTER //
// ./src/main.js